import React from 'react';
import PropTypes from 'prop-types';
import { updateSummary } from '../../../../services/wire/edit-services';
import debounceAction from '../../../../shared/debounce-action';
import Loading from '../../../../shared/loading';

const WarningIcon = () => (
  <svg style={{ top: '2px' }} className="warning-icon relative mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1477_57225)">
      <path d="M7.99992 5.33329V7.99996M7.99992 10.6666H8.00659M14.6666 7.99996C14.6666 4.31806 11.6818 1.33329 7.99992 1.33329C4.31802 1.33329 1.33325 4.31806 1.33325 7.99996C1.33325 11.6819 4.31802 14.6666 7.99992 14.6666C11.6818 14.6666 14.6666 11.6819 14.6666 7.99996Z" stroke="#B71E49" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1477_57225">
        <rect width="16" height="16" fill="white" transform="matrix(1 0 0 -1 0 16)" />
      </clipPath>
    </defs>
  </svg>
);

export default class StandfirstSummary extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      summary: this.props.value || '',
      summaryLength: this.props.value.length || 0,
    };

    this.saveSummary = debounceAction({
      getCurrentValue: () => this.state.summary,
      actionPromise: () => updateSummary(this.props.wireId, this.state.summary),
      onBeforeAction: () => this.loading.start(),
      onAfterAction: () => this.loading.stop(),
      wait: 2000,
    });
  }

  componentDidMount() {
    this.summaryElement = document.querySelector('.wire-standfirst-summary textarea');
    this.summaryElement.addEventListener('keydown', event => {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    });
    this.summaryElement.addEventListener('keyup', event => {
      this.setState(state => {
        state.summary = event.target.value;
        state.summaryLength = state.summary.length;
        return state;
      }, this.saveSummary);
      this.setHeight();
      this.controlWarning(this.state.summaryLength);
    });

    this.setHeight();
  }

  setHeight() {
    setTimeout(() => {
      if (this.state.summary === '') {
        this.summaryElement.style.height = '25px';
      } else {
        this.summaryElement.style.height = 'auto';
        this.summaryElement.style.height = `${this.summaryElement.scrollHeight}px`;
      }
    }, 10);
  }

  // eslint-disable-next-line class-methods-use-this
  controlWarning(length) {
    const warning = document.querySelector('.warning');
    if (length > 140) {
      warning.classList.remove('hidden');
    } else {
      warning.classList.add('hidden');
    }
  }

  render() {
    return (
      <div className="wire-standfirst-summary mb-6 relative">
        <p className="sip-controls absolute right-0 top-0">
          <Loading variant="sip" ref={el => (this.loading = el)} />
        </p>
        <textarea
          style={{ height: 0 }}
          className="resize-none paragraph-lg focus:ring-0 w-full overflow-hidden p-0 border-none focus:border-none hover:border-none"
          placeholder="Write your standfirst here"
          defaultValue={this.state.summary}
        />
        <div className="flex justify-end mt-2 text-sm text-right font-semibold">
          <div className={`warning flex ${this.state.summaryLength <= 140 ? 'hidden' : ''}`}>
            <WarningIcon />
            <span>Standfirst cannot be more than 140 characters</span>
          </div>
          <span style={{ color: this.state.summaryLength > 140 ? '#B71E49' : '' }} className="inline-block w-16 text-secondary text-sm">{`${this.state.summaryLength}/140`}</span>
        </div>
      </div>
    );
  }
}
